import { FormControlLabel, Checkbox } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Minus from "../../../components/svg/Minus";
import Plus from "../../../components/svg/Plus";

const NewsletterSetting: React.FC<INewsletterFormProps> = (props) => {
  const { t } = useTranslation();
  const { isEdit = true, onChangeData, data } = props;
  const [state, setState] = useState<INewsletterFormState>({
    userMetaData: {},
  });
  const { userMetaData } = state;
  const [visibleForms, setVisibleForms] = useState<boolean>(true);

  useEffect(() => {
    if (onChangeData) {
      onChangeData(userMetaData ?? {});
    }
  }, [state]);


  useEffect(() => {
    setState((prevState) => {
      const baseData = data ? { ...data } : { ...prevState.userMetaData };
      const currentAdvertimes = baseData.newsletterSubscription?.advertimes;
      const isFromAdverTimes = baseData.transition_source === "advertimes";

      const mergedMetaData = {
        ...baseData,
        newsletterSubscription: {
          ...baseData.newsletterSubscription,
          advertimes:
            currentAdvertimes !== undefined
              ? currentAdvertimes
              : isFromAdverTimes,
        },
      };

      if (
        JSON.stringify(prevState.userMetaData) !==
        JSON.stringify(mergedMetaData)
      ) {
        return {
          ...prevState,
          userMetaData: mergedMetaData,
        };
      }

      return prevState;
    });
  }, [data]);

  const handleChange =
    (field: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
      const checked = event.target.checked;

      setState((prevState) => ({
        ...prevState,
        userMetaData: {
          ...prevState?.userMetaData,
          newsletterSubscription: {
            ...prevState.userMetaData?.newsletterSubscription,
            [field]: checked,
          },
        },
      }));
    };

  return (
    <div className="component__basic-interests">
      <h3
        className="basic-interests_title"
        onClick={() => isEdit && setVisibleForms(!visibleForms)}
        style={{ cursor: isEdit ? "pointer" : "default" }}
      >
        <img className="-icon" src="/images/ico_mail.svg" />
        {t("features.userSetting.newsletter.newsletterTit")}
        {isEdit && (visibleForms ? <Minus /> : <Plus />)}
      </h3>
      {visibleForms ? (
        <>
          <dl className="basic-interests_body">
            <div
              className={`body-item ${isEdit ? "item_edit" : "item_confirm"}`}
            >
              <dt className="-middle">
                <label className={`${isEdit ? "" : "pr0"}`}>
                  <span>{t("features.userSetting.newsletter.newsletter")}</span>
                </label>
              </dt>
              <dd>
                <>
                  {isEdit ? (
                    <dl>
                      <dt>{t("features.notification.kaigiHotTopics")}</dt>
                      <dd className="d-grid">
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="sendenkaigiInfo"
                              onChange={handleChange("sendenkaigiInfo")}
                              value={1}
                              checked={
                                userMetaData?.newsletterSubscription
                                  ?.sendenkaigiInfo ?? false
                              }
                              sx={{
                                color: "#009999",
                                "&.Mui-checked": {
                                  color: "#009999",
                                },
                                "& .MuiSvgIcon-root": {
                                  fontSize: "16px",
                                },
                              }}
                              size="small"
                            />
                          }
                          label={t("features.notification.sendenkaigiInfo")}
                          sx={{
                            "& .MuiFormControlLabel-label": {
                              fontSize: "14px",
                            },
                          }}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="classInfo"
                              onChange={handleChange("classInfo")}
                              // value={2}
                              checked={
                                userMetaData?.newsletterSubscription
                                  ?.classInfo ?? false
                              }
                              sx={{
                                color: "#009999",
                                "&.Mui-checked": {
                                  color: "#009999",
                                },
                                "& .MuiSvgIcon-root": {
                                  fontSize: "16px",
                                },
                              }}
                              size="small"
                            />
                          }
                          label={t("features.notification.classInfo")}
                          sx={{
                            "& .MuiFormControlLabel-label": {
                              fontSize: "14px",
                            },
                          }}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="contestsAwards"
                              onChange={handleChange("contestsAwards")}
                              value={5}
                              checked={
                                userMetaData?.newsletterSubscription
                                  ?.contestsAwards ?? false
                              }
                              sx={{
                                color: "#009999",
                                "&.Mui-checked": {
                                  color: "#009999",
                                },
                                "& .MuiSvgIcon-root": {
                                  fontSize: "16px",
                                },
                              }}
                              size="small"
                            />
                          }
                          label={t("features.notification.contestsAwards")}
                          sx={{
                            "& .MuiFormControlLabel-label": {
                              fontSize: "14px",
                            },
                          }}
                        />
                      </dd>
                    </dl>
                  ) : userMetaData?.newsletterSubscription?.sendenkaigiInfo ||
                    userMetaData?.newsletterSubscription?.classInfo ||
                    userMetaData?.newsletterSubscription?.contestsAwards ? (
                    <>
                      <div className="mb-2 text-bold">
                        {t("features.notification.kaigiHotTopics")}
                      </div>
                      {userMetaData?.newsletterSubscription
                        ?.sendenkaigiInfo && (
                        <div className="mb-2">
                          {t("features.notification.sendenkaigiInfo")}
                        </div>
                      )}
                      {userMetaData?.newsletterSubscription.classInfo && (
                        <div className="mb-2">
                          {t("features.notification.classInfo")}
                        </div>
                      )}
                      {userMetaData?.newsletterSubscription.contestsAwards && (
                        <div className="mb-2">
                          {t("features.notification.contestsAwards")}
                        </div>
                      )}
                    </>
                  ) : (
                    <>
                      <div className="mt-3 text-bold">
                        {t("features.notification.kaigiHotTopics")}
                      </div>
                      <div className="mb-2">未選択</div>
                    </>
                  )}
                  {isEdit ? (
                    <dl>
                      <dt>編集部からのBreaking News</dt>
                      <dd className="d-grid">
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="advertimes"
                              onChange={handleChange("advertimes")}
                              value={14}
                              checked={
                                userMetaData?.newsletterSubscription
                                  ?.advertimes ?? false
                              }
                              sx={{
                                color: "#009999",
                                "&.Mui-checked": {
                                  color: "#009999",
                                },
                                "& .MuiSvgIcon-root": {
                                  fontSize: "16px",
                                },
                              }}
                              size="small"
                            />
                          }
                          label={t("features.notification.adverTimesCheckBox")}
                          sx={{
                            "& .MuiFormControlLabel-label": {
                              fontSize: "14px",
                            },
                          }}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="digitalMagazine"
                              onChange={handleChange("digitalMagazine")}
                              value={15}
                              checked={
                                userMetaData?.newsletterSubscription
                                  ?.digitalMagazine ?? false
                              }
                              sx={{
                                color: "#009999",
                                "&.Mui-checked": {
                                  color: "#009999",
                                },
                                "& .MuiSvgIcon-root": {
                                  fontSize: "16px",
                                },
                              }}
                              size="small"
                            />
                          }
                          label={t("features.notification.magazineCheckBox")}
                          sx={{
                            "& .MuiFormControlLabel-label": {
                              fontSize: "14px",
                            },
                          }}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="editorialSendenkaigi"
                              onChange={handleChange("editorialSendenkaigi")}
                              value={8}
                              checked={
                                userMetaData?.newsletterSubscription
                                  ?.editorialSendenkaigi ?? false
                              }
                              sx={{
                                color: "#009999",
                                "&.Mui-checked": {
                                  color: "#009999",
                                },
                                "& .MuiSvgIcon-root": {
                                  fontSize: "16px",
                                },
                              }}
                              size="small"
                            />
                          }
                          label={t(
                            "features.notification.editorialSendenkaigi",
                          )}
                          sx={{
                            "& .MuiFormControlLabel-label": {
                              fontSize: "14px",
                            },
                          }}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="editorialHansokukaigi"
                              onChange={handleChange("editorialHansokukaigi")}
                              value={10}
                              checked={
                                userMetaData?.newsletterSubscription
                                  ?.editorialHansokukaigi ?? false
                              }
                              sx={{
                                color: "#009999",
                                "&.Mui-checked": {
                                  color: "#009999",
                                },
                                "& .MuiSvgIcon-root": {
                                  fontSize: "16px",
                                },
                              }}
                              size="small"
                            />
                          }
                          label={t(
                            "features.notification.editorialHansokukaigi",
                          )}
                          sx={{
                            "& .MuiFormControlLabel-label": {
                              fontSize: "14px",
                            },
                          }}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="editorialKohokaigi"
                              onChange={handleChange("editorialKohokaigi")}
                              value={11}
                              checked={
                                userMetaData?.newsletterSubscription
                                  ?.editorialKohokaigi ?? false
                              }
                              sx={{
                                color: "#009999",
                                "&.Mui-checked": {
                                  color: "#009999",
                                },
                                "& .MuiSvgIcon-root": {
                                  fontSize: "16px",
                                },
                              }}
                              size="small"
                            />
                          }
                          label={t("features.notification.editorialKohokaigi")}
                          sx={{
                            "& .MuiFormControlLabel-label": {
                              fontSize: "14px",
                            },
                          }}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="editorialBrain"
                              onChange={handleChange("editorialBrain")}
                              value={9}
                              checked={
                                userMetaData?.newsletterSubscription
                                  ?.editorialBrain ?? false
                              }
                              sx={{
                                color: "#009999",
                                "&.Mui-checked": {
                                  color: "#009999",
                                },
                                "& .MuiSvgIcon-root": {
                                  fontSize: "16px",
                                },
                              }}
                              size="small"
                            />
                          }
                          label={t("features.notification.editorialBrain")}
                          sx={{
                            "& .MuiFormControlLabel-label": {
                              fontSize: "14px",
                            },
                          }}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="environmentalBusinessOnline"
                              onChange={handleChange(
                                "environmentalBusinessOnline",
                              )}
                              value={9}
                              checked={
                                userMetaData?.newsletterSubscription
                                  ?.environmentalBusinessOnline ?? false
                              }
                              sx={{
                                color: "#009999",
                                "&.Mui-checked": {
                                  color: "#009999",
                                },
                                "& .MuiSvgIcon-root": {
                                  fontSize: "16px",
                                },
                              }}
                              size="small"
                            />
                          }
                          label={t(
                            "features.notification.environmentalBusinessOnline",
                          )}
                          sx={{
                            "& .MuiFormControlLabel-label": {
                              fontSize: "14px",
                            },
                          }}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="environmentalBusinessOnlineNews"
                              onChange={handleChange(
                                "environmentalBusinessOnlineNews",
                              )}
                              value={9}
                              checked={
                                userMetaData?.newsletterSubscription
                                  ?.environmentalBusinessOnlineNews ?? false
                              }
                              sx={{
                                color: "#009999",
                                "&.Mui-checked": {
                                  color: "#009999",
                                },
                                "& .MuiSvgIcon-root": {
                                  fontSize: "16px",
                                },
                              }}
                              size="small"
                            />
                          }
                          label={t(
                            "features.notification.environmentalBusinessOnlineNews",
                          )}
                          sx={{
                            "& .MuiFormControlLabel-label": {
                              fontSize: "14px",
                            },
                          }}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="editorialBooks"
                              onChange={handleChange("editorialBooks")}
                              value={7}
                              checked={
                                userMetaData?.newsletterSubscription
                                  ?.editorialBooks ?? false
                              }
                              sx={{
                                color: "#009999",
                                "&.Mui-checked": {
                                  color: "#009999",
                                },
                                "& .MuiSvgIcon-root": {
                                  fontSize: "16px",
                                },
                              }}
                              size="small"
                            />
                          }
                          label={t("features.notification.editorialBooks")}
                          sx={{
                            "& .MuiFormControlLabel-label": {
                              fontSize: "14px",
                            },
                          }}
                        />
                      </dd>
                    </dl>
                  ) : userMetaData?.newsletterSubscription?.advertimes ||
                    userMetaData?.newsletterSubscription?.digitalMagazine ||
                    userMetaData?.newsletterSubscription
                      ?.editorialSendenkaigi ||
                    userMetaData?.newsletterSubscription
                      ?.editorialHansokukaigi ||
                    userMetaData?.newsletterSubscription?.editorialKohokaigi ||
                    userMetaData?.newsletterSubscription?.editorialBrain ||
                    userMetaData?.newsletterSubscription
                      ?.environmentalBusinessOnline ||
                    userMetaData?.newsletterSubscription
                      ?.environmentalBusinessOnlineNews ||
                    userMetaData?.newsletterSubscription?.editorialBooks ? (
                    <>
                      <div className="mb-2 text-bold">
                        編集部からのBreaking News
                      </div>
                      {userMetaData?.newsletterSubscription?.advertimes && (
                        <div className="mb-2">
                          {t("features.notification.adverTimesCheckBox")}
                        </div>
                      )}
                      {userMetaData?.newsletterSubscription.digitalMagazine && (
                        <div className="mb-2">
                          {t("features.notification.magazineCheckBox")}
                        </div>
                      )}
                      {userMetaData?.newsletterSubscription
                        .editorialSendenkaigi && (
                        <div className="mb-2">
                          {t("features.notification.editorialSendenkaigi")}
                        </div>
                      )}
                      {userMetaData?.newsletterSubscription
                        .editorialHansokukaigi && (
                        <div className="mb-2">
                          {t("features.notification.editorialHansokukaigi")}
                        </div>
                      )}
                      {userMetaData?.newsletterSubscription
                        .editorialKohokaigi && (
                        <div className="mb-2">
                          {t("features.notification.editorialKohokaigi")}
                        </div>
                      )}
                      {userMetaData?.newsletterSubscription.editorialBrain && (
                        <div className="mb-2">
                          {t("features.notification.editorialBrain")}
                        </div>
                      )}
                      {userMetaData?.newsletterSubscription
                        .environmentalBusinessOnline && (
                        <div className="mb-2">
                          {t(
                            "features.notification.environmentalBusinessOnline",
                          )}
                        </div>
                      )}
                      {userMetaData?.newsletterSubscription
                        .environmentalBusinessOnlineNews && (
                        <div className="mb-2">
                          {t(
                            "features.notification.environmentalBusinessOnlineNews",
                          )}
                        </div>
                      )}
                      {userMetaData?.newsletterSubscription.editorialBooks && (
                        <div className="mb-2">
                          {t("features.notification.editorialBooks")}
                        </div>
                      )}
                    </>
                  ) : (
                    <>
                      <div className="mt-3 text-bold">
                        編集部からのBreaking News
                      </div>
                      <div className="mb-2">未選択</div>
                    </>
                  )}

                  {isEdit ? (
                    <dl>
                      <dt>Additional Information</dt>
                      <dd className="d-grid">
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="adPlacementSponsorship"
                              onChange={handleChange("adPlacementSponsorship")}
                              // value={16}
                              checked={
                                userMetaData?.newsletterSubscription
                                  ?.adPlacementSponsorship ?? false
                              }
                              sx={{
                                color: "#009999",
                                "&.Mui-checked": {
                                  color: "#009999",
                                },
                                "& .MuiSvgIcon-root": {
                                  fontSize: "16px",
                                },
                              }}
                              size="small"
                            />
                          }
                          label={t(
                            "features.notification.adPlacementSponsorship",
                          )}
                          sx={{
                            "& .MuiFormControlLabel-label": {
                              fontSize: "14px",
                            },
                          }}
                        />
                      </dd>
                    </dl>
                  ) : userMetaData?.newsletterSubscription
                      ?.adPlacementSponsorship ? (
                    <>
                      <div className="mb-2 text-bold">
                        Additional Information
                      </div>
                      {userMetaData?.newsletterSubscription
                        ?.adPlacementSponsorship && (
                        <div className="mb-2">
                          {t("features.notification.adPlacementSponsorship")}
                        </div>
                      )}
                    </>
                  ) : (
                    <>
                      <div className="mt-3 text-bold">
                        Additional Information
                      </div>
                      <div className="mb-2">未選択</div>
                    </>
                  )}
                </>
              </dd>
            </div>
          </dl>
        </>
      ) : (
        ""
      )}
    </div>
  );
};

export default NewsletterSetting;
